<template>
  <div class="order-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="orderList"
        height="56vh"
        border
        stripe
        @row-click="handleViewDetail"
        row-key="id"
        style="width: 100%"
      >
        <el-table-column prop="order_dh" label="订单号" min-width="220" show-overflow-tooltip />
        <el-table-column prop="status_jie" label="接单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getJieStatusType(scope.row.status_jie)" size="small">
              {{ scope.row.status_jie }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getOrderStatusType(scope.row.status)" size="small">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="付款状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getPayTypeType(scope.row.pay_type)" size="small">
              {{ scope.row.pay_type }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="quhuo" label="收货状态" width="100" /> -->
        <el-table-column prop="refund_amount" label="退款金额(元)" width="140">
          <template slot-scope="scope">
            <span class="money">¥{{ parseFloat(scope.row.refund_amount || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v6" label="支付方式" width="120" />
        <el-table-column prop="comlist3" label="下单时间" width="180" />
        <el-table-column prop="com_name" label="购买公司名称" width="180" />
        <el-table-column prop="buyer_name" label="下单人" width="180" />
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-view"
              @click.stop="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
            <!-- 如有取消售后需求可放开 -->
            <!-- <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click.stop="cancelAfterSale(scope.row)"
            >
              取消售后
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="售后订单详情" :visible.sync="dialogVisible" width="60%">
      <el-descriptions :column="2" border v-if="currentOrder" class="detail-descriptions">
        <el-descriptions-item label="订单号">{{ currentOrder.order_dh }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{ currentOrder.sh_name }}</el-descriptions-item>
        <el-descriptions-item label="接单状态">{{ currentOrder.status_jie }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ currentOrder.status }}</el-descriptions-item>
        <el-descriptions-item label="付款状态">{{ currentOrder.pay_type }}</el-descriptions-item>
        <!-- <el-descriptions-item label="收货状态">{{ currentOrder.quhuo }}</el-descriptions-item> -->
        <el-descriptions-item label="退款金额">
          <span class="money">¥{{ parseFloat(currentOrder.refund_amount || 0).toFixed(2) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ currentOrder.comlist_v6 }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ currentOrder.comlist3 }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ currentOrder.comlist_v2 }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentOrder.comlist_v3 }}</el-descriptions-item>
        <el-descriptions-item label="提货方式">{{ currentOrder.comlist_v1 }}</el-descriptions-item>
        <el-descriptions-item label="期望提货日">{{ currentOrder.comlist_v5 }}</el-descriptions-item>
        <el-descriptions-item label="购买公司名称">{{ currentOrder.com_name }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{ currentOrder.mx_list?.[0]?.detail_address || '' }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="currentOrder && currentOrder.mx_list && currentOrder.mx_list.length" class="mx-section">
        <h4 class="mx-title">商品明细</h4>
        <el-table :data="currentOrder.mx_list" border stripe size="small">
          <el-table-column prop="comlist_v1" label="商品名称" min-width="280" show-overflow-tooltip />
          <el-table-column prop="comlist_s1" label="数量" width="100" align="center" />
          <el-table-column prop="comlist_f1" label="单价(元)" width="120" align="center">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.comlist_f1 || 0).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'AfterSaleList',
  data () {
    return {
      loading: false,
      orderList: [],
      filterForm: {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentOrder: null
    }
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    // ----- 获取售后列表 -----
    async getOrderList () {
      this.loading = true
      try {
        const shId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const params = {
          a: 'salelists',
          page: this.currentPage,
          pageSize: this.pageSize,
          sh_id: shId,
          user_type: userType,
          ...this.filterForm
        }
        // 移除空字段
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        // 日期字段映射
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date = this.dateRange[1]
        }
        const response = await request.post('/shouhou/shouhou_list.php', params)

        if (response.code === '0') {
          this.orderList = response.data || []
          // 假设返回 total 或根据 pages 计算
          this.total = response.total || (response.pages * this.pageSize) || 0
        } else {
          this.$message.error(response.msg || '获取售后列表失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求售后列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.orderList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // ----- 筛选与分页 -----
    handleSearch () {
      this.currentPage = 1
      this.getOrderList()
    },

    handleReset () {
      this.filterForm = {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getOrderList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getOrderList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },

    // ----- 查看详情 -----
    handleViewDetail (row) {
      this.currentOrder = row
      this.dialogVisible = true
    },

    // ----- 状态标签样式 -----
    getJieStatusType (status) {
      const map = { 可接单: 'success', 配货中: 'warning', 已完成: 'info', 已作废: 'danger' }
      return map[status] || 'info'
    },
    getOrderStatusType (status) {
      const map = { 待发货: 'warning', 已发货: 'success', 退货中: 'danger', 已处理: 'info' }
      return map[status] || 'info'
    },
    getPayTypeType (payType) {
      const map = { 待付款: 'danger', 已支付: 'success', 已退款: 'warning' }
      return map[payType] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.money { color: #ee530c; }
.order-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card { .filter-form { margin-bottom: 0; } }
  .table-card {
    .pagination { margin-top: 20px; text-align: right; }
    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px; height: 40px;
      background-color: #f5f7fa;
      color: #909399;
      font-size: 20px;
    }
  }
}
.detail-descriptions { margin-bottom: 20px; }
.mx-section {
  margin-top: 16px;
  border-top: 1px solid #ebeef5;
  padding-top: 16px;
  .mx-title {
    margin: 0 0 12px 0;
    font-size: 15px;
    color: #303133;
  }
}
</style>
